// const APIENDPOINT = 'http://172.26.0.144:5000' // máquina Ana
//const APIENDPOINT = 'http://cee-api-pro.eu-west-1.elasticbeanstalk.com'; // PRE - AWs EBS
const APIENDPOINT = 'https://api.eventosconferenciaepiscopal.es'; // PRO - AWs EBS
// const APIENDPOINT = 'http://cee-api-pro.eu-west-1.elasticbeanstalk.com' // PRO - AWS EBS
const CLIENTID = 'backoffice';
const CLIENTSECRET = 'eurostar2017';

export { APIENDPOINT, CLIENTID, CLIENTSECRET };
